import { config } from '../domain/config'
import { googleApi } from '../data/googleApi'
import type { ApiCaller } from '../data/googleRepository'

export const teacherApi: ApiCaller = async (action, payload, credential) => config.mode === 'supabase'
  ? (await import('../data/supabaseApi')).supabaseApi(action, payload, credential)
  : googleApi(action, payload, credential)
